<template>
	<catalog-picker-component 
		ref="c"
		:disabled="disabled" 
		auth		
		v-model="selectedCounterparty"
		placeholder="Поиск контрагентов по инициалам, телефону"
		search-url="/api/counterparties/search"
		@update:modelValue="onSelectChange">
		<template #label>
			{{ `${selectedCounterparty?.lastname} ${selectedCounterparty?.firstname} ${selectedCounterparty?.middlename ?? ''}` }}
		</template>
		<template #default="scope">
			{{ `${scope.lastname} ${scope.firstname} ${scope.middlename}` }}
		</template>
	</catalog-picker-component>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import ApplicationTab from '@/models/ApplicationTab';
import CounterpartyModel from '@/models/CounterpartyModel';
import CatalogPickerComponent from '../CatalogPickerComponent.vue';

@Options({	
	components: {
		CatalogPickerComponent
	},
	props: {
		disabled: Boolean,
		auth: Boolean,
		searchUrl: String,
		catalogTab: ApplicationTab,
		searchResultsMap: Function,
		placeholder: String,
		allowCreating: Boolean,
		multiple: Boolean,
		emitChangeEvent: Boolean
	},
	emits: ['selected'],
})
export default class CounterpartyFilterComponent extends Vue {
	/** props */
	disabled!: boolean;
	auth!: boolean;
	searchUrl!: string;
	placeholder!: string;
	searchResultsMap!: Function;
	catalogTab!: ApplicationTab;
	allowCreating!: boolean;
	multiple!: boolean;
	emitChangeEvent!: boolean;

	/** view-models */
	selectedCounterparty: CounterpartyModel | null = null;	

	onSelectChange(selectedCounterparty: CounterpartyModel) {
		this.$emit('selected', selectedCounterparty);
	}

	set(item: any) {
		const catalogPickerComponent = this.$refs.c as any;
		catalogPickerComponent.set(item);		
	}
}
</script>